export default "__VITE_ASSET__Dv3Jx8m___"